import { render, staticRenderFns } from "./EditorHTMLComponent.vue?vue&type=template&id=6052e6fe"
import script from "./EditorHTMLComponent.vue?vue&type=script&lang=js"
export * from "./EditorHTMLComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports